import React, {useState} from 'react';

import {useNavigation, useRoute} from '@react-navigation/native';

import {CheckoutSession} from '../../../../components/shared/Payments/CheckoutSession';
import {VehicleDebits} from '../../../../components/shared/Payments/CheckoutSession/modules/VehicleDebits';
import {RootStackParamList} from '../../../../dtos/RoutesDTO';
import {PromoModal} from '../../../../components/Interface/PromoModal';
import {useGlobal} from '../../../../context/global';
import {Maintenance} from '../../../../components/Interface/Maintenance';

export function PP_Checkout() {
  const route = useRoute();

  const [showModal, setShowModal] = useState(false);

  const navigation = useNavigation();

  const {disabledFeatures} = useGlobal();
  const isDisabled = (key: string) => disabledFeatures.includes(key);

  const {consultaId, placa, uids, uuid, value, enablePix} =
    route.params as RootStackParamList['PP_Checkout'];

  function handleNavigation() {
    setShowModal(false);
    navigation.navigate('VehicleDebits');
  }

  if (isDisabled('multas')) {
    return <Maintenance />;
  }

  return (
    <>

        {
          <PromoModal
            buttonText="Sim, sair"
            buttonAction={handleNavigation}
            isVisible={showModal}
            text="Ao sair, você precisará buscar os débitos do veículo novamente."
            title="Sair do pagamento?"

            onDismiss={() => setShowModal(false)}
          />
        }

      <CheckoutSession
        enablePix={enablePix}
        enableDiscounts={false}
        enableBaratinhas={false}
        enableVale={false}
        enableBrbDiscount={false}
        showReferAndWinButton={false}
        onGoBack={() => setShowModal(true)}
        enablePendingPayment={false}
        module={
          <VehicleDebits
            value={value}
            consulta_id={consultaId}
            placa={placa}
            uids={uids}
            uuid={uuid}
            tipo_operacao="debito_veicular"
          />
        }
      />
    </>
  );
}
